export default (contract: string | GQL.IContractDetails) => {
  if (typeof contract === 'string') return contract;
  else return contract.originalContract || contract.contract;
};
